module.exports = __webpack_public_path__ + "static/media/temp_background_2.41ce569c.jpg";